import React from 'react';
import { TextInput } from '@carbon/react';

const WatchfolderSettings: React.FC = () => (
  <>
    {/* <p className="settings-page__tab-copy">Keep ingest folders tidy by enforcing quotas and retention windows.</p> */}
    <div className="settings-page__form-grid">
      <TextInput id="watchfolder-quota" labelText="Max folders" placeholder="25" />
      <TextInput id="watchfolder-retention" labelText="Retention (days)" placeholder="14" />
    </div>
  </>
);

export default WatchfolderSettings;
